var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "mobile-page" }, [
        _c("div", { staticClass: "member-benefits", style: _vm.boxStyle }, [
          _vm.progressShow
            ? _c(
                "div",
                { staticClass: "level-section", style: _vm.progressBoxBg },
                [
                  _c(
                    "div",
                    { staticClass: "level-progress" },
                    _vm._l(_vm.levelList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "level-item" },
                        [
                          _c("div", { staticClass: "level-top" }, [
                            index > 0
                              ? _c("div", {
                                  staticClass: "line-left",
                                  style: _vm.lineColor,
                                })
                              : _vm._e(),
                            index < _vm.levelList.length - 1
                              ? _c("div", {
                                  staticClass: "line-right",
                                  style: _vm.lineColor,
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "node",
                                style: {
                                  background:
                                    index <= _vm.currentLevel
                                      ? _vm.achieveColor
                                      : _vm.notAchievedColor,
                                },
                              },
                              [
                                index < _vm.currentLevel
                                  ? _c("div", {
                                      staticClass: "node-point",
                                      style: { background: _vm.achieveColor },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            index === _vm.currentLevel
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "current-badge",
                                    style: { background: _vm.achieveColor },
                                  },
                                  [_vm._v("当前")]
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "level-name",
                              style: _vm.levelColor,
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm.rightsShow
            ? _c(
                "div",
                { staticClass: "benefit-section", style: _vm.levelBoxBg },
                [
                  _c(
                    "div",
                    { staticClass: "benefit-list" },
                    _vm._l(_vm.benefitList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "benefit-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-box" },
                            [_c("el-image", { attrs: { src: item.icon } })],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "benefit-name",
                              style: { color: _vm.rightsColor },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }